import { Constants } from '../constants/constants';
import { Device } from '../../providers/traccar-client';

export function hasRecoveryServiceAddon(attributes: Device['attributes']): boolean {
  return (
    attributes?.subscription?.addons?.some((addon) => Constants.RECOVERY_SERVICE_ADDON_IDS.includes(addon.id)) ?? false
  );
}
